import React from 'react';
import { ButtonProps } from 'react-bootstrap';
import GatedButton, { permissionDeniedMessage } from './GatedButton';
import { PermissionField } from '../Common/permissions';
import { usePermission } from './usePermission';

export { permissionDeniedMessage };

type Props = ButtonProps & { permission: PermissionField };

const PermissionButton = ({ permission, ...buttonProps }: Props) =>
  <GatedButton allowed={usePermission(permission)} {...buttonProps} />;

export default PermissionButton;
